<template>
  <v-container fluid>
    <!-- <v-container fluid> -->
      <v-row>
        <global-EventFilterMenu 
          header='Stock Control Filters'
          showStallholders
          headerButtonText="Generate Stock level csv"
          :headerButtonAction="generateStockLevelCSV"
        />
       </v-row>
   
    <v-row>
      <v-col
        cols="12"
      >
        <v-card
          dark
          outlined
          height="100"
        >
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-swap-horizontal-bold </v-icon>
            Stock Transfer
            <v-spacer/>
            <v-btn small>
              Generate stock level csv
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
      >
        <v-card
          dark
          outlined
          height="500"
        >
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-file-table </v-icon>
            Remaining Stock Levels
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import {
  mapActions
} from 'vuex';
import 'izitoast/dist/css/iziToast.min.css';
import iziToast from 'izitoast/dist/js/iziToast.min.js';

export default {
  methods: {
      ...mapActions('dashboard', ['prepareReport', 'getReports']),

    generateStockLevelCSV() {
      this.prepareReport('stockLevelCSV').then(stockLevelCSV => {
        console.log('stockLevelCSV: ', stockLevelCSV)
        iziToast.success({
          title: 'Stock Level CSV',
          message: "Generating stock level csv, standby",
          position: 'topRight'
        });
        this.getReports(stockLevelCSV).then(response => {
          console.log('getStockLevelCSV Response: ', response);
          this.presignedurl = response.S3presignedurl;
          window.open(this.presignedurl, "_blank");
        }).catch(err => {
          console.error(err);
          iziToast.warning({
            title: 'Stock Level CSV',
            message: 'Error getting Stock Level CSV, please contact TSG',
            position: 'center'
          });
      })
    })
    },
  }
}
</script>

<style scoped>

</style>